import styled from 'styled-components';

import { ANIM, LOGIN, LOGIN_MOBILE } from '../../../../theme/tokens';

/**
 * Login language switcher: label + trigger pill + an upward popover list. The
 * popover class is `language-popover` (deliberately NOT Bootstrap's reserved
 * `dropdown-menu`, whose global `display:none` would hide it). All colours come
 * from the `LOGIN` token group.
 */
export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
  width: 100%;

  .language-switcher-label {
    display: block;
    font-size: 12px;
    line-height: 20px;
    color: ${LOGIN.langLabel};
  }

  .language-dropdown {
    position: relative;
    display: inline-block;
  }

  .language-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    min-height: 36px;
    padding: 8px 16px;
    border: 0;
    border-radius: 999px;
    background: ${LOGIN.langTriggerBg};
    font-size: 14px;
    font-weight: 500;
    color: ${LOGIN.langTriggerText};
    user-select: none;

    .flag {
      font-size: 18px;
      line-height: 1;
    }
    .name {
      font-weight: 500;
    }
    .caret {
      font-size: 16px;
      opacity: 0.8;
      display: inline-flex;
    }
  }

  /* Width is driven by the widest option (\`width: max-content\` + stretched rows),
     so every row is exactly as wide as the longest language label needs. Anchored
     to the trigger's left edge, opening upward. */
  .language-popover {
    position: absolute;
    left: 0;
    bottom: calc(100% + 8px);
    z-index: 10;
    padding: 8px;
    width: max-content;
    border-radius: 16px;
    background: ${LOGIN.langMenuBg};
    border: 1px solid ${LOGIN.langMenuBorder};
    box-shadow: ${LOGIN.langMenuShadow};
  }

  .language-menu {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  /* Vertical list; rows stretch to the panel (= widest option) width so the
     hover / active highlight spans the full row. */
  .languages {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }

  .language-option {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    cursor: pointer;
    padding: 10px 12px;
    border-radius: 10px;
    font-size: 14px;
    color: ${LOGIN.langOptionText};
    user-select: none;
    transition: background-color ${ANIM.INTERACT_MS}ms ease, color ${ANIM.INTERACT_MS}ms ease;

    .flag {
      font-size: 18px;
      line-height: 1;
    }

    &:hover {
      background: ${LOGIN.langOptionHover};
    }

    &.active {
      color: ${LOGIN.langActive};
      font-weight: 600;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .language-option {
      transition: none;
    }
  }

  ${LOGIN_MOBILE} {
    margin: 0 auto;
    max-width: 100%;
  }
`;
